define([
    'system/domain/entity/tag',
    'common/util/material-colors',
    'backbone'
], function(
    Tag,
    Color,
    Backbone
    ){
    var TagCollection = Backbone.Collection.extend({
        model: Tag,

        initialize: function() {
            this.on('add', this.setColor);
            this.on('change', function(tag) {
                if(tag.get('deleted')) {
                    tag.trigger('remove');
                }
            });
        },

        comparator: function(tag) {
            return tag.get('name');
        },

        getByIds: function(ids) {
            return this.filter(function(tag) {
                return !tag.get('deleted') && _.contains(ids, tag.id);
            }, this);
        },

        setColor: function(tag) {
            if(tag.get('color')) {
                return;
            }

            var color = null;
            for(var i = 0; i < 3; i++) {
                color = Color.pickRandom();
                if(this.where({color: color}).length == 0) {
                    break;
                }
            }

            tag.set({color: color});
        }
    });

    return TagCollection;
});



// WEBPACK FOOTER //
// ./system/domain/collection/tag.js